import { intl } from '@approvalmax/utils';

import { estimatedMonthlyTransactionValues, estimatedMonthlyTransactionVolumes } from '../../constants';
import { messages } from './StepForm.messages';

export const estimatedMonthlyTransactionVolumeTextMap: Record<
    (typeof estimatedMonthlyTransactionVolumes)[number],
    string
> = {
    1: messages.oneOff,
    20: messages.rangePerMonth({ range: '1-20' }),
    50: messages.rangePerMonth({ range: '20-50' }),
    100: messages.rangePerMonth({ range: '50-100' }),
    150: messages.rangePerMonth({ range: '100+' }),
};

export const estimatedMonthlyTransactionValueTextMap: Record<
    (typeof estimatedMonthlyTransactionValues)[number],
    (currency: string) => string
> = {
    10000: (currency: string) => `< ${intl.formatCurrency(10_000, currency, 0)}`,
    50000: (currency: string) =>
        `${intl.formatCurrency(10_000, currency, 0)} - ${intl.formatCurrency(50_000, currency, 0)}`,
    100000: (currency: string) =>
        `${intl.formatCurrency(50_000, currency, 0)} - ${intl.formatCurrency(100_000, currency, 0)}`,
    500000: (currency: string) =>
        `${intl.formatCurrency(100_000, currency, 0)} - ${intl.formatCurrency(500_000, currency, 0)}`,
    600000: (currency: string) => intl.formatCurrency(500_000, currency, 0).split(' ').join('+ '),
};
